import React from "react";
import { FormattedMessage } from "react-intl";
import { KeyValue } from "@folio/stripes/components";
import css from "./LibraryNoteRow.module.css";
export var LibraryNoteRow = function (_a) {
    var note = _a.note;
    var hasText = !!note && note.text !== "";
    return (React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.libraryNote.label" }), value: hasText ? React.createElement("div", { className: css.noteText }, note.text) : undefined }));
};
